module.exports = __webpack_public_path__ + "media/output360.59816c2a.mp4";